div.popover,
:host {
 --popover-border-radius: var(--uui-border-radius-md);
 --popover-padding: var(--uui-medium-padding);
 --popover-box-shadow: 0px 2px 24px 0px rgba(0,0,0,0.33);
 --popover-border: 1px solid var(--uui-theme-variant-700);
 --popover-max-width: 400px;
 --popover-width: 200px;
 --popover-height: fit-content;
 --popover-top: 10px;
 --popover-z-index: 2;
}

div.container {
  position: relative;
}

div.popover {
  transition: opacity 0.5s;
  z-index: var(--popover-z-index);
  box-sizing: border-box;
  padding: var(--popover-padding);
  box-shadow: var(--popover-box-shadow);
  border: var(--popover-border);
  width: var(--popover-width);
  height: var(--popover-height);
  top: var(--popover-top);
  background-color: var(--popover-background, #fff);
  border-radius: var(--popover-border-radius);
  position: absolute;
  max-width: var(--popover-max-width);
}

div.popover::after {
  content: '';
  height: 100%;
  width: 100%;
  border-radius: 4px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

div.popover.hide-arrow::after {
  width: 0;
  height: 0;
}

div.popover::before {
  content: '';
  width: 20px;
  height: 20px;
  transform: rotate(45deg);
  background: var(--popover-background, #fff);
  position: absolute;
  z-index: -1;
}

div.popover.left::before  {
  top: -4px;
  left: 8px;
}

div.popover.right::before  {
  top: -4px;
  right: 8px;
}

div.popover.middle::before  {
  top: -4px;
  right: calc(var(--popover-width) / 2 - 10px);
}

:host[event-type="click"]:host[opened] div.popover {
  opacity: 1;
}


div.popover.show {
  opacity: 1;
}

div.popover.hide {
  opacity: 0;
  visibility: hidden;
}
